<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h1>Authentification</h1>
                <p class="text-muted">Authentification requise</p>
                <div class="alert alert-danger" v-if="error">
                  <p>Identifiant ou mot de passe non valide</p>
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input type="text" autofocus class="form-control" v-model.trim="data.body.username" placeholder="identifiant" name="username">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input v-on:keyup.enter="login" type="password" class="form-control" v-model.trim="data.body.password" placeholder="Mot de passe" name="password">
                </div>
                <div class="row">
                  <div class="col-6">
                    <button type="button" v-on:click="login" class="btn btn-primary px-4">S'identifier</button>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-link px-0">Mot de passe oublié ?</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>Pas d'identifiant</h2>
                  <p>Si vous n'avez pas reçu vos identifiants rapprochez vous de contact [@] domaine-de-limagne.com</p>
                  <!-- a href="mailto:support_dashboard@no-limit-network.com"><button type="button" class="btn btn-primary active mt-3">Contactez-nous</button></a>  -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
  name: 'Login',
  data: function () {
    return {
      context: 'login',
      redirect: '/',
      data: {
        body: { username: '', password: '' },
        rememberMe: false
      },
      error: false
    }
  },
  methods: {
    login () {
      this.$Progress.start()
      this.error = false
      this.$http.post(process.env.API_URL + '/auth/login', this.data).then((response) => {
        this.loader = false
        this.$ls.set('token', response.body.meta.token)
        console.log('token: ' + this.$ls.get('token') + ' vs ' + response.body.meta.token)
        this.$http.headers.common['Authorization'] = 'Bearer ' + this.$ls.get('token')
        store.commit('LOGIN_USER')
        console.log('token stored')
        this.$Progress.finish()
        router.push('/')
      },
      () => {
        this.error = true
        this.loader = false
        this.password = ''
        this.$Progress.fail()
        this.$ls.remove('token')
        store.commit('LOGOUT_USER')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?9919c61c